// extracted by mini-css-extract-plugin
export default {"bgVideo":"BgVideo_bgVideo__TovGW"};